import { IkeToken, IkeUserRole, type UserProfileJSONObject } from '@ikegps/core-api';
import { action, computed, observable, type ObservableMap, makeObservable } from 'mobx';
import { Services } from '../../services';
import type { DepartmentUserProfile } from '../../services/user.profile.service';
import { IkeSort } from '../../sort';

export class AccountsCtrl {
	loading: ObservableMap<string, boolean> = observable.map<string, boolean>();

	constructor() {
		makeObservable(this);
	}

	@computed get users(): DepartmentUserProfile[] {
		if (Services.Department.current == null) {
			return [];
		}

		const users = (Services.UserProfile.list || []).slice();
		IkeSort.byKey(users, ['role', 'username'], IkeSort.ASC);

		return users;
	}

	@computed get isDepartmentAdmin() {
		for (const account of this.users) {
			if (account.objectId === Services.User.current.objectId && Services.UserProfile.isDepartmentAdmin(account)) {
				return true;
			}
		}
		return false;
	}

	canRemove(role: IkeUserRole): boolean {
		return role === IkeUserRole.USER;
	}

	haveExtraRoles(): boolean {
		return Services.Token.has(IkeToken.FEATURE_EXTRA_ROLES) || Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE);
	}

	inviteUsers(emails: string[], role: IkeUserRole) {
		return Services.Department.Invite.request(emails, role);
	}

	@action setLoading(objectId: string, loading: boolean) {
		if (loading) {
			this.loading.set(objectId, true);
		} else {
			this.loading.delete(objectId);
		}
	}

	removeUser(user: UserProfileJSONObject): Promise<any> {
		return this.setRole(user, IkeUserRole.NONE);
	}

	setUserRole(user: UserProfileJSONObject, role: IkeUserRole): Promise<any> {
		return this.setRole(user, role);
	}

	private async setRole(user: UserProfileJSONObject, role: IkeUserRole): Promise<any> {
		const objectId = user.objectId;
		this.setLoading(objectId, true);
		await Services.Department.setUserRole(objectId, role);
		this.setLoading(objectId, false);
	}

	isLoadingUser(user: UserProfileJSONObject): boolean {
		return this.loading.has(user.objectId);
	}
}
